import React from 'react';

import classes from './MissionControlLayersFilters.module.scss';
import MSearchInput from 'views/MSearchInput/MSearchInput';
import MQuickFiltersButton from 'views/MTable/TableFilters/MQuickFiltersButton/MQuickFiltersButton';
import MFilter from 'views/MTable/TableFilters/MQuickFiltersButton/MFilter/MFilter';
import { ITableFilterOptions } from 'views/MTable/TableFilters/MQuickFiltersButton/MFilter/MFilter.model';
import { OnChangeValue } from 'react-select';
import { MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';
import JobStatus from 'utils/enums/job-status';
import DatetimeRangePicker from 'views/MDatetimePicker/MDatetimeRangePicker/MDatetimeRangePicker';
import moment from 'moment';
import { ConnectorPowerLabel, ConnectorTypeLabel } from 'utils/enums/chargingType';

type Props = {
  dateFilters: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  };
  statusOptions: ITableFilterOptions[];
  powerTypeOptions: ITableFilterOptions[];
  connectorTypeOptions: ITableFilterOptions[];
  statusFilters: MSelectOption<null, JobStatus>[];
  zonesFilters: readonly MSelectOption[];
  powerTypeFilters: MSelectOption<null, ConnectorPowerLabel>[];
  generalFilterValue: string;
  connectorTypeFilters: MSelectOption<null, ConnectorTypeLabel>[];
  onZonesFilterChange: (value: OnChangeValue<MSelectChangeData, true>) => void;
  onStatusFilterChange: (value: OnChangeValue<MSelectChangeData<null, JobStatus>, true>) => void;
  onPowerTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorPowerLabel>, true>) => void;
  onDateFilterChange: (startDate: moment.Moment | null, endDate: moment.Moment | null) => void;
  onRemoveStatusFilter: (id: JobStatus) => void;
  onRemoveZonesFilter: (id: string) => void;
  onResetDate?: () => void;
  onGeneralFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearGeneralFilter: () => void;
  onConnectorTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorTypeLabel>, true>) => void;
};

const MissionControlLayersFiltersView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {

  return (
    <div className={classes['container']}>
      <div className={classes['content']}>
        <div className={classes['generalFilter']}>
          <MSearchInput
            onClearGeneralFilters={props.onClearGeneralFilter}
            onChange={props.onGeneralFilterChange}
            value={props.generalFilterValue}
            className={classes['generalFilterInput']}
            alwaysOpen
          ></MSearchInput>
        </div>

        <DatetimeRangePicker
          startDate={props.dateFilters.startDate}
          endDate={props.dateFilters.endDate}
          onChange={props.onDateFilterChange}
          onResetDate={props.onResetDate}
        ></DatetimeRangePicker>
        <MQuickFiltersButton
          className={classes['filters']}
          filtersJSX={[
            {
              id: 'status',
              jsxFunc: () => (
                <MFilter
                  key={1}
                  nameKey="missionControl.layers.filters.status.title"
                  fixedOptions={props.statusOptions}
                  isTranslationKey
                  value={props.statusFilters}
                  onChange={props.onStatusFilterChange}
                  bottomToTop
                ></MFilter>
              ),
            },
            {
              id: 'driver',
              jsxFunc: () => (
                <MFilter
                  key={2}
                  nameKey="missionControl.layers.filters.zones.title"
                  collection="driver" // TODO:WILL BE RPLACED BY ZONE zone
                  value={props.zonesFilters}
                  onChange={props.onZonesFilterChange}
                  bottomToTop
                ></MFilter>
              ),
            },
            {
              id: 'powerType',
              jsxFunc: () => (
                <MFilter
                  key={3}
                  nameKey="missionControl.layers.filters.powerType.title"
                  fixedOptions={props.powerTypeOptions}
                  isTranslationKey
                  value={props.powerTypeFilters}
                  onChange={props.onPowerTypeFilterChange}
                  bottomToTop
                ></MFilter>
              ),
            },
            {
              id: 'connectorType',
              jsxFunc: () => (
                <MFilter
                  key={4}
                  nameKey="missionControl.layers.filters.connectorType.title"
                  fixedOptions={props.connectorTypeOptions}
                  isTranslationKey
                  value={props.connectorTypeFilters}
                  onChange={props.onConnectorTypeFilterChange}
                  bottomToTop
                ></MFilter>
              ),
            },
          ]}
        ></MQuickFiltersButton>
      </div>
    </div>
  );
};

MissionControlLayersFiltersView.displayName = 'MissionControlLayersFiltersView';
MissionControlLayersFiltersView.defaultProps = {};

export default MissionControlLayersFiltersView;
